<template>
        <full-screen-overlay @close="backToProject" backTo="Project">

            <div class="w-full h-full flex flex-col items-center justify-center text-center p-4">

                <typography variant="h4">Welcome back!</typography>
                <typography variant="p" class="text-gray-600 mt-2 max-w-xl">If you've made any changes to your billing, they'll be updated soon in the project. Please continue to check back over the next few minutes.</typography>

                <router-link
                        :to="{ name: 'Project' }"
                        title="Back To Project"
                        class="text-secondary dark:text-secondary-300 underline focus:outline-none focus:shadow-outline mt-4 hover:opacity-75 transition duration-150"
                    >
                        Back To Project
                </router-link>

            </div>

        </full-screen-overlay>
</template>

<script>
import { LayoutComponents } from '@/modules/Dashboard/components'
import { authenticationState, loading, error } from '@/mixins';
import { updateAuthenticationState } from "@/graphql/mutations";

export default {
    name: "StripeReturn",
    metaInfo: {
      title: 'Welcome Back',
    },
    mixins: [LayoutComponents, authenticationState, loading, error ],
    async created () {
        try {

            await this.$apollo.mutate({
                    mutation: updateAuthenticationState,
                    variables: {
                        selectedProject: this.$route.params.projectId
                    },
            });

        } catch (error) {
            this.handleError(error);
        }

    },
    methods: {
        backToProject () {
            this.$router.push({ name: "Project" })
        }
    }
}
</script>